export * from './DetailsModalNavToolbar'
export * from './DetailsNavItem'


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/DetailsNavToolbar/index.ts